module.exports = __webpack_public_path__ + "img/jose.ebb7e621.png";